import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ResultTable from "../../Table/ResultTable";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import CheckCSName from "../../CheckCSName";
import ResultCellHighlight from "../../Table/ResultCellHighlight";

export default function SV6({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV6_SV06.error_id: {
            return (
                <ResultText>

                    The bridge width is not consistent with the survey data at the following {row?.data?.length} bridges:
                    <ResultTable maxWidth={HecRasHelper.getWidth(70)} data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>Bridge</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Width</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {
                                    return (
                                        <>
                                            <ResultRow>
                                                <ResultBodyCell rowSpan={3} style={{width: HecRasHelper.getWidth(20), textAlign: 'left', verticalAlign: 'top'}}>
                                                    RS <CheckCSName csName={r?.cross_section} />
                                                </ResultBodyCell>
                                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Left</ResultHeaderCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {r?.left?.toFixed(2)}
                                                </ResultBodyCell>
                                            </ResultRow>

                                            <ResultRow>
                                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Right</ResultHeaderCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {r?.right?.toFixed(2)}
                                                </ResultBodyCell>
                                            </ResultRow>

                                            <ResultRow>
                                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {r?.bridge_width?.toFixed(2)}
                                                </ResultBodyCell>
                                            </ResultRow>
                                        </>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </ResultText>
            )
        }
    }
}